import { render } from "./LaptopPage.vue?vue&type=template&id=eaf6492c&scoped=true"
import script from "./LaptopPage.vue?vue&type=script&lang=js"
export * from "./LaptopPage.vue?vue&type=script&lang=js"

import "./LaptopPage.vue?vue&type=style&index=0&id=eaf6492c&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eaf6492c"]])

export default __exports__